"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformLocationsToNearbyResultItems = exports.transformLocationsToPoints = exports.transformLocationsToNearbyResultItem = exports.transformLocationToPoint = void 0;
var NeighbourhoodInfo_1 = require("@/pages/place/states/NeighbourhoodInfo");
exports.transformLocationToPoint = function (place) {
    return {
        name: place.locationName,
        lat: place.okayAddress.latitude,
        lng: place.okayAddress.longitude,
        type: NeighbourhoodInfo_1.NeighbourhoodItemType.PIN,
    };
};
exports.transformLocationsToNearbyResultItem = function (place) {
    return {
        name: place.locationName,
        position: {
            lat: place.okayAddress.latitude,
            lng: place.okayAddress.longitude,
        },
        caption: place.okayAddress.address,
    };
};
exports.transformLocationsToPoints = function (places) {
    return places ? places.map(exports.transformLocationToPoint) : [];
};
exports.transformLocationsToNearbyResultItems = function (places) {
    return places ? places.map(exports.transformLocationsToNearbyResultItem) : [];
};
